import { Theme as AugmentedTheme } from '@mui/material';


import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) =>
({
  subheader: {
    marginBottom: theme.spacing(6),
  },
  documentBadgeContainer: {
    marginTop: theme.spacing(6),
  },
  backButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
    },
  },
  submitButton: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
    },
  },
  buttonContainer: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(8),
  },
  feePreviewText: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },

  errorText: {
    color: theme.color.state.stateError,
    marginTop: theme.spacing(4),
  },
  stepper: {
    position: 'relative',
    [theme.breakpoints.up('xl')]: {
      left: '-10%',
    },
    [theme.breakpoints.between('lg', 'xl')]: {
      left: '-10%',
    },
    [theme.breakpoints.between('md', 'xl')]: {
      left: '-2.5%',
    },
    [theme.breakpoints.between('sm', 'lg')]: {
      left: '-2.5%',
    },
    [theme.breakpoints.down('md')]: {
      left: '-3%',
    },
  },
  bottomButtonGroup: {
    marginBottom: theme.spacing(7),
  },
}));

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export default useStyles;
